module.exports = __webpack_public_path__ + "img/tranquilo_md.34ead710.jpg";